const findAndRemove = (list, fn) => {
    const index = list.findIndex(fn);
    if (index !== -1) {
        list.splice(index, 1);
    }
    return list;
};

export default findAndRemove;
